import styled from '@emotion/styled';
import LazyLoadTable from '__components/Kizen/LazyLoad/LazyLoadTable';
import BigTableLayout from '__components/Layout/BigTableLayout';
import { grayScale } from '__app/colors';
import Input from '__components/Kizen/Input';
import { breakpoints } from '__app/spacing';
import { ToolbarLeft, ToolbarWrapper } from '__pages/Common/styles/ControlBar';
import css from '@emotion/css';
import BasicModalWithConfirmation from '__components/Modals/presets/BasicModalWithConfirmation';
interface StyledToolbarLeftProps {
  nameBreakpoint: number;
}

export const StyledLazyLoadTable = styled(LazyLoadTable)`
  position: relative;
  width: auto;
  thead {
    z-index: 0;
  }
`;

export const StyledBigTableLayout = styled(BigTableLayout)`
  min-height: auto;

  table {
    background-color: ${grayScale.white};
  }

  && > div {
    padding: 0;
  }

  && > div:last-child > div:last-child {
    margin-bottom: 25px;
  }
`;

export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 36px;
  margin: 20px 0;
`;

export const TBSearchInput = styled(Input)`
  max-width: 200px;

  label {
    margin: 0;
  }

  .input-wrapper {
    margin: 0;
    background-color: ${grayScale.white};
  }

  input {
    min-width: 0;
    padding-right: 0;
  }
`;

export const PaginationWrapper = styled.div`
  padding: 20px 0 2px 0;
`;

export const StyledToolbarWrapper = styled(ToolbarWrapper)`
  position: relative;

  @media (min-width: ${breakpoints.md + 1}px) {
    padding: 0 20px;
  }
`;

export const StyledTabsWrapper = styled.div`
  background-color: ${grayScale.white};
  max-width: 450px;
  width: 100%;
  margin: 20px auto;

  button:not(:last-of-type) {
    border-right: 1px solid ${grayScale.mediumLight};
  }

  button:focus {
    outline: 0;
  }

  button:after {
    height: 0px;
  }
`;

export const StyledToolbarLeft = styled(ToolbarLeft)<StyledToolbarLeftProps>`
  display: flex;
  align-items: center;
  min-width: fit-content;

  > * {
    &:not(:last-child) {
      margin-right: 35px;
    }
  }

  @media (min-width: ${breakpoints.md + 1}px) {
    display: flex;
    flex: 0 0 51px;

    > button {
      margin-right: 0;
      padding-right: 0;
    }
  }

  ${({ nameBreakpoint }) => css`
    @media (min-width: ${nameBreakpoint + 1}px) {
      min-width: fit-content;
    }
  `}
`;

export const StyledBasicModalWithConfirmation = styled(
  BasicModalWithConfirmation
)`
  .modal-content {
    .modal-body {
      > div {
        padding: 0;

        > div > div {
          margin-top: 0;
        }
      }

      padding-top: 0;
    }

    padding-top: 0;
  }
`;
export const DateTimeInputWrapper = styled.div`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`;
